/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios"
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"
import { Infraccion } from "../infracciones/hooks/useInfraccionesAPI"

export interface ConfiguracionEPagos {
    UrlApi: string
    IdOrganismoEpagos: string
    TipoOperacionEpagos?: string
    IdUsuarioEpagos: string
    HashEpagos: string
    PasswordEpagos: string
    ConvenioEpagos: string
    ImplementadorEPagos: string
}

export interface ConveniosPagoConfiguracion extends Model {
    PlataformaPago: ("EPAGOS" | "HELIPAGOS")
    PrefijoSolicitudPago: string
    Nombre: string
    EPagos?: ConfiguracionEPagos
    ConfiguracionesProduccion: {Id:number}[]
    DescuentosPermitidos:{Porcentaje:number}[]
    Template:string
    DiasVencimiento:number
    CotizacionUF:number
    GastosAdministrativos:number
}

export interface ConveniosPagoConfiguracionForm extends Omit<ConveniosPagoConfiguracion, 'ConfiguracionesProduccion'|'DescuentosPermitidos'> {
    ConfiguracionesProduccion: number[]
    DescuentosPermitidos: number[]
}
export interface ConveniosPagoConfiguracionSave extends Omit<ConveniosPagoConfiguracion, 'ConfiguracionesProduccion'|'DescuentosPermitidos'> {
    ConfiguracionesProduccion: string
    DescuentosPermitidos: string
}
const module = "ConveniosPagoConfiguracion";

export default () => {
    const api = useApi({ module });    

    return {
        list: (query: Query) => api.list!<ConveniosPagoConfiguracion>(query),
        save: (data: Partial<ConveniosPagoConfiguracionSave>) => api.save!<Partial<ConveniosPagoConfiguracionSave>, ConveniosPagoConfiguracion>(data),
        delete: (id: number) => api.delete!<ConveniosPagoConfiguracion>(id)
    };
}